"use client";

import { useEffect } from "react";

type AppErrorProps = {
  error: Error & { digest?: string };
  reset: () => void;
};

export default function Error({ error, reset }: AppErrorProps) {
  useEffect(() => {
    console.error("[app/error]", {
      message: error.message,
      digest: error.digest,
      stack: error.stack,
    });
  }, [error]);

  return (
    <main className="flex min-h-[100vh] flex-col items-center justify-center bg-[color:var(--color-white)] px-4 text-center text-[color:var(--color-black)]">
      <p className="text-sm uppercase tracking-[0.08em] text-[color:var(--color-red)]">
        Error de aplicación
      </p>
      <h1 className="mt-3 text-3xl font-bold">Ocurrió un error inesperado.</h1>
      <p className="mt-3 max-w-[520px] text-base">
        Reintentá la carga. Si vuelve a pasar, revisá la consola para ver el stack exacto.
      </p>
      <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
        <button
          type="button"
          onClick={() => reset()}
          className="rounded-[2px] border border-[color:var(--color-red)] bg-[color:var(--color-red)] px-5 py-2 text-sm font-medium uppercase text-[color:var(--color-white)] focus-visible:outline focus-visible:outline-[2px] focus-visible:outline-offset-[2px] focus-visible:outline-[color:var(--color-black)]"
        >
          Reintentar
        </button>
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="rounded-[2px] border border-[color:var(--color-black)] bg-[color:var(--color-white)] px-5 py-2 text-sm font-medium uppercase text-[color:var(--color-black)] focus-visible:outline focus-visible:outline-[2px] focus-visible:outline-offset-[2px] focus-visible:outline-[color:var(--color-black)]"
        >
          Recargar
        </button>
      </div>
    </main>
  );
}
